<template>
  <CreateShopLoader v-if="isCreateShopLoading" />
  <div v-else>
    <GlobalEvents
      @keyup.escape="clearSuggestedCompanyRegistrations"
      @click="handleClickOutside"
    />
    <div
      v-if="isContractChangeFromSalesforce"
      class="collapsable-shop-content"
    >
      <CollapsableShopDetailsForm
        v-for="(shopInfo, index) in nonCreatedShopPaymentInfos"
        :key="shopInfo.salesforceId || index"
        ref="collapsableShopDetailsForm"
        :shop-payment-infos="shopInfo"
        :line-items-infos="lineItemsInfos[0]"
        :is-form-submitted="shopInfo.isFormSubmitted"
        @form-submitted="() => onShopFormSubmitted(index)"
      />
    </div>
    <ShopDetailsForm
      v-else
      ref="shopDetailsForm"
      :shop-payment-infos="shopsPaymentInfos[0]"
      :line-items-infos="lineItemsInfos[0]"
      @toggle-submit="toggleSubmit"
    />
    <div
      v-if="!isBillingOnOrganisation"
      class="create-shop__disclamer__wrapper"
    >
      <span class="sk-text-x-small-regular">
        {{ $t('create_shop.disclamer') }}
      </span>
      <span class="sk-text-x-small-regular">
        <i18n path="create_shop.terms_of_service">
          <template #linkTerms>
            <SkOroraLink
              target="_blank"
              rel="noopener noreferrer"
              size="x-small"
              :href="$t('create_shop.link_terms_of_service')"
            >
              {{ $t('create_shop.text_terms_of_service') }}
            </SkOroraLink>
          </template>
          <template #linkPrivacy>
            <SkOroraLink
              target="_blank"
              rel="noopener noreferrer"
              size="x-small"
              :href="$t('create_shop.link_privacy_policy')"
            >
              {{ $t('create_shop.text_privacy_policy') }}
            </SkOroraLink>
          </template>
        </i18n>
      </span>
    </div>
  </div>
</template>
<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';

import GlobalEvents from 'vue-global-events';

import ShopDetailsForm from '@components/ShopDetailsForm';
import CreateShopLoader from '@views/CreateShopLoader';
import CollapsableShopDetailsForm from '@components/CollapsableShopDetailsForm/index.vue';

export default {
  name: 'CreateShop',
  components: {
    CollapsableShopDetailsForm,
    CreateShopLoader,
    GlobalEvents,
    ShopDetailsForm,
  },
  props: {
    isCreateShopLoading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['isBillingOnOrganisation', 'isContractChangeFromSalesforce']),
    ...mapState(['shopsPaymentInfos', 'lineItemsInfos']),
    nonCreatedShopPaymentInfos() {
      return this.shopsPaymentInfos.filter(shop => !shop.SK_shop_id);
    },
  },
  methods: {
    ...mapMutations(['setShopFormSubmitted']),
    handleClickOutside(event) {
      if (!this.isContractChangeFromSalesforce) {
        if (this.$refs.shopDetailsForm.$refs.dropdown?.$el?.contains(event.target)) return;

        this.$refs.shopDetailsForm.clearSuggestedCompanyRegistrations();
        return;
      }

      const collapsableForms = this.$refs.collapsableShopDetailsForm;
      if (collapsableForms) {
        if (collapsableForms.some(
          form => form.$refs.shopDetailsForm?.$refs.dropdown?.$el?.contains(event.target))
        ) return;

        collapsableForms.forEach(form => {
          if (form.$refs.shopDetailsForm) {
            form.$refs.shopDetailsForm.clearSuggestedCompanyRegistrations();
          }
        });
      }
    },
    clearSuggestedCompanyRegistrations() {
      if (!this.isContractChangeFromSalesforce) {
        this.$refs.shopDetailsForm.clearSuggestedCompanyRegistrations();
        return;
      }

      const collapsableForms = this.$refs.collapsableShopDetailsForm;
      if (collapsableForms) {
        collapsableForms.forEach(form => {
          if (form.$refs.shopDetailsForm) {
            form.$refs.shopDetailsForm.clearSuggestedCompanyRegistrations();
          }
        });
      }
    },
    toggleSubmit(value) {
      if (value) {
        this.$emit('disable-submit');
      } else {
        this.$emit('enable-submit');
      }
    },
    onShopFormSubmitted(index) {
      const shopIndex = this.shopsPaymentInfos.findIndex(
        shop => shop.salesforceId === this.nonCreatedShopPaymentInfos[index].salesforceId,
      );
      this.setShopFormSubmitted({ index: shopIndex, isFormSubmitted: true });

      if (this.nonCreatedShopPaymentInfos.every(shop => shop.isFormSubmitted)) {
        this.$emit('enable-submit');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.span-bank-transfer {
  font-weight: 600;
}

.bank-transfert-description {
  margin-top: 16px;
  margin-bottom: 0px;
}

.bank-transfer-payment-label {
  margin-top: 32px;
  margin-bottom: 0px;
}

.collapsable-shop-content {
  margin-top: 24px;
}

.create-shop__disclamer__wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
